export default __webpack_public_path__ + "static/media/LeagueLogos.ad844d5e.png";